import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { settingsApi, type FooterConfig } from "../../api/endpoints";

export function useFooter() {
  return useQuery({
    queryKey: ["settings", "footer"],
    queryFn: () => settingsApi.getFooter().then((r) => r.data),
  });
}

export function useUpdateFooter() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: FooterConfig) => settingsApi.setFooter(data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["settings", "footer"] }),
  });
}
